/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { EFSRestoreDestination } from '../models/EFSRestoreDestination';

export class RestoreEFSRequest {
  /**
  * Eon-assigned ID of the restore account where the EFS file system will be restored.
  */
  'restoreAccountId': string;
  'destination': EFSRestoreDestination;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "restoreAccountId",
      "baseName": "restoreAccountId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "destination",
      "baseName": "destination",
      "type": "EFSRestoreDestination",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RestoreEFSRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

